module.exports = __webpack_public_path__ + "img/box2.1260a08c.png";